import { TEntityUntagged } from '@obvious.tech/constellation/Entity'
import { TEntityOverride } from 'src/types'

const override: TEntityOverride<TEntityUntagged<'AnalyticsProfile'>> = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      id: {
        displayedName: 'ID',
      },
      profileName: {
        displayedName: 'Profile Name',
      },
      type: {
        displayedName: 'Type',
      },
      fullName: {
        displayedName: 'Full Name',
      },
      hasPhoto: {
        displayedName: 'Has Photo ?',
      },
      lastLocation: {
        displayedName: 'Last Location',
      },
      lastLocationDate: {
        displayedName: 'Last Location Date',
      },
      isBlackListed: {
        displayedName: 'Is Blacklisted ?',
      },
      blacklistedAt: {
        displayedName: 'Blacklisted At',
      },
      humanDetails: {
        displayedName: 'Human Details',
      },
      vehicleDetails: {
        displayedName: 'Vehicle Details',
      },
      comment: {
        displayedName: 'Comment',
      },
    },
  },
}

export default override
